import { useEffect } from 'react';

import { onAdvancedSearchViewed } from '../../../common/utils/events/advanced-search-viewed';
import { useReferrer, useSearchSessionId } from '../../store/bootstrap';
import { useAnalytics } from '../index';

export const AdvancedSearchViewed = () => {
	const { fireAnalyticsScreenEvent } = useAnalytics();
	const [searchSessionId] = useSearchSessionId();
	const [referrer] = useReferrer();

	useEffect(() => {
		fireAnalyticsScreenEvent(onAdvancedSearchViewed(searchSessionId, referrer));
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return null;
};
